<modal
  #modal
  class="popup"
  [name]="localStorageKeys.ti_modal_question"
  [minWidth]="minWidth || 650"
  [width]="width"
  [maxWidth]="maxWidth"
  [ignoreEscKey]="!!denyClose"
  (closeOut)="!denyClose && buttonClick(closeButton, true)">
  <modal-header [noCloseButton]="!!autoCloseDelayTime || !!denyClose" class="popup-header">
    <span
      class="wrapper-header--title"
      [innerHTML]="title"
      [ngClass]="{ 'wrapper-header--title-danger': (isWarning || dangerTitle) && !suppressDangerTitle }"></span>
  </modal-header>
  <modal-body class="popup-body">
    <div *ngIf="warningText" class="warning-block">
      <div class="icon-block">
        <i class="fa fa-exclamation-circle icon"></i>
      </div>
      <div class="warning-message" [innerHTML]="warningText"></div>
    </div>

    <div class="content">
      <span *ngIf="icon" class="{{ icon }}"></span>
      <p *ngIf="autoCloseDelayTime" [innerHTML]="html"></p>
      <ti-html-content *ngIf="!autoCloseDelayTime" [content]="text"></ti-html-content>
    </div>
    <div *ngIf="id" class="no-more-questions-check">
      <input
        type="checkbox"
        id="question-component-no-more-questions"
        class="k-checkbox"
        [(ngModel)]="noMoreQuestions" />
      <label class="k-checkbox-label" for="question-component-no-more-questions">{{ strings.noMoreQuestions }}</label>
    </div>
  </modal-body>
  <modal-actions *ngIf="buttons?.length">
    <button
      kendoButton
      *ngFor="let button of buttons"
      fillMode="{{button?.outline ? 'outline' : 'solid'}}"
      [themeColor]="getButtonThemeColor(button)"
      (click)="buttonClick(button)"
      [hidden]="button.hidden">
      {{ button.text }}
    </button>
  </modal-actions>
</modal>

<ti-spinner *ngIf="isLoading"></ti-spinner>
